module.exports = __webpack_public_path__ + "static/img/zf1.83ddb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zf1.png
// module id = c0rr
// module chunks = 1